module.exports = __webpack_public_path__ + "static/media/ru_2.ceeea1e0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Components/HelpDialogContent/ru_2.gif
// module id = 298
// module chunks = 3